export const methods = {
    words: {
        data: {
            fetch: "ai-helper.words.data.fetch"},
        problemWords: {
            list: "ai-helper.words.problemWords.list"},
        create: "ai-helper.words.create"},
    tasks: {
        pendingEnrich: {
            list: "ai-helper.tasks.pendingEnrich.list"},
        list: "ai-helper.tasks.list",
        get: "ai-helper.tasks.get",
        update: "ai-helper.tasks.update"},
    plans: {
        create: "ai-helper.plans.create",
        process: "ai-helper.plans.process",
        list: "ai-helper.plans.list",
        status: {
            update: "ai-helper.plans.status.update"}},
    elements: {
        review: "ai-helper.elements.review"},
    tagsHierarchy: {
        review: "ai-helper.tagsHierarchy.review"},
    images: {
        generate: "ai-helper.images.generate"},
    parts: {
        available: {
            list: "ai-helper.parts.available.list"}},
    problemReasons: {
        list: "ai-helper.problemReasons.list"},
    dq: {
        openIssues: {
            list: "ai-helper.dq.openIssues.list",
            count: "ai-helper.dq.openIssues.count"},
        rules: {
            list: "ai-helper.dq.rules.list",
            get: "ai-helper.dq.rules.get",
            upsert: "ai-helper.dq.rules.upsert",
            setEnabled: "ai-helper.dq.rules.setEnabled"}},
    jobs: {
        prompt: "ai-helper.jobs.prompt",
        llm: "ai-helper.jobs.llm",
        parse: "ai-helper.jobs.parse"}};


  export const typedMethods = {};
